import React from 'react';
import { Radio } from '@domain-group/fe-blueprint-ui/form';
import * as styles from './selector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Selector = _ref => {
  var name = _ref.name,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    selectedValue = _ref.selectedValue,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? () => {} : _ref$onSelect,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'list' : _ref$type,
    className = _ref.className;
  var renderOptions = () => options.map((option, index) => {
    var optionButton = ___EmotionJSX("span", {
      css: styles.subheading({
        radio: type === 'radio',
        indented: type === 'list'
      })
    }, option.label);
    if (option.value) {
      var isSelected = option.value === selectedValue;
      if (type === 'radio') {
        optionButton = ___EmotionJSX(Radio, {
          checked: isSelected,
          name: name,
          css: styles.radio(option.indented),
          onChange: () => {
            if (option.value) {
              onSelect(option.value);
            }
          },
          labelContent: option.label || option.component
        });
      } else if (option.component) {
        optionButton = ___EmotionJSX("div", {
          css: styles.button({
            selected: isSelected,
            indented: option.indented
          })
        }, option.component);
      } else {
        optionButton = ___EmotionJSX("button", {
          css: styles.button({
            selected: isSelected,
            indented: option.indented
          }),
          disabled: option.disabled,
          onClick: () => {
            if (!option.disabled && option.value) {
              onSelect(option.value);
            }
          },
          type: "button"
        }, option.label);
      }
    }
    return ___EmotionJSX("li", {
      css: styles.item,
      key: option.value || "NOVALUE-".concat(index)
    }, optionButton);
  });
  return ___EmotionJSX("ul", {
    css: styles.container,
    className: className
  }, renderOptions());
};
export default Selector;